import { useSearchParams } from "react-router-dom";

// Manage if a DocViewer is in diff mode
export const useIsDiffMode = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const isDiffMode = searchParams.get("diff") === "true";

  const setIsDiffMode = (next: boolean) =>
    setSearchParams((sp) => {
      if (next) {
        sp.set("diff", "true");
      } else {
        sp.delete("diff");
      }
      return sp;
    });

  return { isDiffMode, setIsDiffMode };
};
